<template>
    <div v-bind:class="['form-group', { 'has-error': question.error }]">
        <label v-bind:for="componnentId">
            {{ question.question }}
            <span v-if="question.required" class="small" v-bind:class="{ 'span-error': question.error }">
                * {{ requiredMessage }}
            </span>
        </label>
        <select 
            v-model="question.answer" 
            v-bind:id="componnentId" 
            v-bind:name="componnentId" 
            class="form-control"
            v-bind:class="{ 'red-alert': question.error }">
            <option value="">---</option>
            <option 
                v-for="option in optionsArray" 
                v-bind:value="option" 
                v-bind:key="option">
                {{ option }}
            </option>
        </select>
    </div>
</template>

<script>
export default {
    name: 'FormSelect',
    props: {
        question: Object,
    },
    data() {
        return {
            optionsArray: [],
        };
    },
    mounted() {
        this.parseOptions();
    },
    methods: {
        parseOptions() {
            this.optionsArray = this.question.options.split('%%');
        },
    },
    computed: {
        componnentId() {
            return 'Question' + this.question.msqID;
        },
        requiredMessage() {
            return this.question.error ? this.question.error : 'Required';
        },
    },
};
</script>
